export enum RequestCategoryEnum {
    // Проточные системы
    flowingSystems = 1,

    // Коттеджные системы
	cottageSystems = 2,

	// Пурифаеры
	purifairs = 3,

	// Бытовые осмо
	householdOsmo = 4,

	// BRO/Barista
	BROBarista = 5,

	// Забор проб специалистом
	sampleCollectionBySpecialist = 11,

	// Прием проб в лаборатории
	sampleReceptionBySpecialist = 12,

	// Поступление проб от сервисной службы
	sampleReceiptByServiceDepartment = 13,

	// Внутренний заказ
	internalOrder = 14,
}